export default `
# When

19.3.2020

9:00 – 15:30

# Where

Slovak Business Agency

Národné podnikateľské centrum - Coworking NPC

Karadžičova 2, Twin City Blok A

811 09 Bratislava
`



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/venue/text.js